import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.DuplicateTask.title',
    defaultMessage: 'Duplicate task',
  },
  confirmPrompt: {
    id: 'containers.OrderPage.components.TaskPage.components.DuplicateTask.confirmPrompt',
    defaultMessage: 'Duplicate this task into the same version? The copy is created without a supplier.',
  },
  success: {
    id: 'containers.OrderPage.components.TaskPage.components.DuplicateTask.success',
    defaultMessage: 'Task duplicated',
  }
})
